import { render } from "./Privacy.vue?vue&type=template&id=d521de3e"
const script = {}

import exportComponent from "E:\\project2\\skin-web\\探险终章20260104\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__